// Client-side "Save as PDF" via the browser's own print engine — no server-side
// headless browser (Puppeteer) involved. We drop the invoice HTML (the SAME
// template used for the on-screen preview) into a hidden iframe and open the
// browser's print dialog, where the user picks "Save as PDF".
//
// Why this instead of server Puppeteer: the production server couldn't run
// headless Chrome reliably (snap confinement / DevTools pipe hangs). The
// browser already renders this exact template for the preview, so print-to-PDF
// reproduces it perfectly — RTL Arabic, multi-page A4, embedded logo — using the
// viewer's own Chrome/Edge/Safari, which always works.
export function printHtmlDocument(html) {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('aria-hidden', 'true');
  Object.assign(iframe.style, {
    position: 'fixed', right: '0', bottom: '0', width: '0', height: '0', border: '0',
  });
  document.body.appendChild(iframe);

  let removed = false;
  const cleanup = () => { if (removed) return; removed = true; try { iframe.remove(); } catch (_) {} };

  iframe.onload = () => {
    const win = iframe.contentWindow;
    if (!win) { cleanup(); return; }
    // Remove the iframe once the print dialog closes; long fallback in case the
    // browser never fires afterprint (removing it mid-dialog would cancel print).
    win.onafterprint = cleanup;
    setTimeout(cleanup, 120000);
    const go = () => { try { win.focus(); win.print(); } catch (_) { cleanup(); } };
    // A document in Arabic or Farsi carries its own font (embedded as a data: URI), and a font is
    // decoded after the page has loaded. Printing before that would print the fallback face, so
    // wait for the document's fonts - but never longer than a couple of seconds.
    const fontsReady = win.document && win.document.fonts && win.document.fonts.ready;
    if (fontsReady && typeof Promise !== 'undefined') {
      Promise.race([fontsReady, new Promise((resolve) => setTimeout(resolve, 2500))])
        .then(() => setTimeout(go, 150), () => setTimeout(go, 250));
    } else {
      // Small delay so layout/images settle before the dialog opens.
      setTimeout(go, 250);
    }
  };

  // srcdoc reliably fires onload after the document renders.
  iframe.srcdoc = html;
}
